import ConstantHelper from "../../Helpers/ConstantHelper";

const VideoAnimationPackagesData = [
  {
    id: "1",
    title: "Classic Video Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "400",
    actualPrice: "800",
    featuresList: [
      { feature: "60 Second Video - HD 1080" },
      { feature: "Professional Script" },
      { feature: "Sample Theme" },
      { feature: "Storyboard" },
      { feature: "Animation" },
      { feature: "Voice - Over & Sound Effects" },
      { feature: "5 weeks Delivery" },
      { feature: "3 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Premium Video Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "700",
    actualPrice: "1400",
    featuresList: [
      { feature: "90 Second Video - HD 1080" },
      { feature: "Professional Script" },
      { feature: "Sample Theme" },
      { feature: "Storyboard" },
      { feature: "Animation" },
      { feature: "Voice - Over & Sound Effects" },
      { feature: "6 Weeks Delivery" },
      { feature: "3 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Deluxe Video Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "900",
    actualPrice: "1800",
    featuresList: [
      { feature: "120 Second Video - HD 1080" },
      { feature: "Professional Script" },
      { feature: "Sample Theme" },
      { feature: "Storyboard" },
      { feature: "Animation" },
      { feature: "Voice - Over & Sound Effects" },
      { feature: "3 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Teaser/Intro Video Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "150",
    actualPrice: "300",
    featuresList: [
      { feature: "15s Duration - HD 1080" },
      { feature: "Professional Script" },
      { feature: "Storyboard" },
      { feature: "Sample Themes" },
      { feature: "Custom Setting, Characters & Graphics" },
      { feature: "Animation Effects & Visualization" },
      { feature: "Voice - Over & Sound Effects (All accents) (M/F)" },
      { feature: "2 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "5",
    title: "Startup Video Package",
    overview:
      "Suitable for potential startups and brand revamps for companies.",
    offerPrice: "200",
    actualPrice: "400",
    featuresList: [
      { feature: "30s Duration - HD 1080" },
      { feature: "Professional Script" },
      { feature: "Storyboard" },
      { feature: "Sample Themes" },
      { feature: "Custom Setting, Characters & Graphics" },
      { feature: "Animation Effects & Visualization" },
      { feature: "Voice - Over & Sound Effects (All accents) (M/F)" },
      { feature: "2 Rounds of Revisions" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

export default VideoAnimationPackagesData;
